export const EMAILJS_CONFIG = {
  SERVICE_ID: "service_j8i73pn", // Identificador do serviço de disparo
  TEMPLATE_ID: "template_fchjvvb", // Modelo de layout do e-mail institucional
  PUBLIC_KEY: "__ghmewHBut_RKmgU", // Chave pública para autenticação via Client-side
};

/**
 * LOGICA DE VALIDAÇÃO
 * Verifica a integridade das credenciais antes de processar o formulário
 */
export const isEmailJSConfigured = () => {
  // Retorna falso se os placeholders padrão ainda estiverem presentes
  return (
    EMAILJS_CONFIG.SERVICE_ID !== "YOUR_SERVICE_ID" &&
    EMAILJS_CONFIG.PUBLIC_KEY !== "YOUR_PUBLIC_KEY"
  );
};
